var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("RegistrationModal", {
        attrs: { "admin-register-mode": true, visible: _vm.createUserDialog },
        on: {
          "close-modal": function ($event) {
            _vm.createUserDialog = false
          },
          "update-user-table": _vm.getUsers,
        },
      }),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "6", md: "10" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Search",
                          "single-line": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center mt-3",
                      attrs: { sm: "6", md: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", "max-width": "100%" },
                          on: {
                            click: function ($event) {
                              _vm.createUserDialog = true
                            },
                          },
                        },
                        [_vm._v(" Add New User ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.users,
              loading: _vm.loading,
              search: _vm.search,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.actions`,
                  fn: function ({ item }) {
                    return [
                      _c("UserModal", {
                        attrs: {
                          id: "adminUserEditModal",
                          user: item,
                          admin: true,
                        },
                        on: { "update-user": _vm.updateUser },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "clickable",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-icon",
                                    _vm._g(
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "", title: "Edit" },
                                      },
                                      on
                                    ),
                                    [_vm._v(" mdi-pencil ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", title: "Delete" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteUserDialog(item)
                            },
                          },
                        },
                        [_vm._v(" mdi-delete ")]
                      ),
                    ]
                  },
                },
                {
                  key: "no-data",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.initialize },
                        },
                        [_vm._v(" Reset ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
          _c("ActionDialog", {
            attrs: {
              type: "user",
              message:
                "Any ownerless groups left by this user will be transfered to an admin.",
            },
            on: {
              cancel: _vm.closeActionDialog,
              confirm: _vm.deleteUserConfirm,
            },
            model: {
              value: _vm.dialogDelete,
              callback: function ($$v) {
                _vm.dialogDelete = $$v
              },
              expression: "dialogDelete",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }